import { daysUntilInquiryOfferDeadline } from '@/utils/inquiryOfferDeadline';

/** True when the deadline is within the next 7 days (including today). */
export function isDeadlineUrgent(deadline: string): boolean {
  const days = daysUntilInquiryOfferDeadline(deadline);
  return days <= 7 && days >= 0;
}
